import React from 'react';
import {createContext} from 'use-context-selector';
import useLocalState from '../util/useLocalState';
import initialLocalData from './initialLocalData';

const LocalContext = createContext(null);
const LocalContextProvider = (props) => {
    const localStorageData = localStorage.getItem('localData');
    const [localData, setLocalData] = useLocalState('localData', localStorageData !== null ? JSON.parse(localStorageData) : {...initialLocalData});
    return (
        <LocalContext.Provider value={[localData, setLocalData]}>
            {props.children}
        </LocalContext.Provider>
    );
};

export {LocalContext, LocalContextProvider};
